module.exports = __webpack_public_path__ + "static/media/seeds.48039a4a.jpg";